// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie';
import plugin from './plugin';

import i18n from './locales'

// import titleMixin from './mixins/titleMixin'
// import errorMixin from './mixins/errorMixin';

Vue.use(VueCookie);

Vue.use(VueAxios, axios)

Vue.use(plugin)

Vue.prototype.$ajax = axios;

Vue.config.productionTip = true

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
});


